/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TaskAssignmentTypeEnum {
    REPORTER = 'REPORTER',
    MEMBERS = 'MEMBERS',
    DATA_SERVICES = 'DATA_SERVICES',
}
